import React from "react";
import "./TermsOfUse.scss";

const TermsOfUse = () => {
    return (
        <div className="terms-of-use">
            <h1>Aspire Terms of Service</h1>
            <p>
                <strong>Last Updated:</strong> June 9, 2025
            </p>

            <h2>1. Acceptance & Scope</h2>
            <p>
                By registering for or using Aspire, you agree to these Terms of Service and any
                related policies (Privacy Policy, Cookie Policy, Community Guidelines). If you are
                accessing the platform on behalf of an organization, you affirm you have
                authorization to bind that entity to these terms.
            </p>

            <h2>2. Eligibility & Account</h2>
            <ul>
                <li>
                    Must be at least <strong>16 years old</strong>, or older if required by local
                    law.
                </li>
                <li>
                    You agree to provide truthful, up-to-date personal information and to safeguard
                    your password.
                </li>
                <li>You are responsible for any activity originating from your account.</li>
            </ul>

            <h2>3. Acceptable Use</h2>
            <h3>You agree to:</h3>
            <ul>
                <li>Use Aspire lawfully, professionally, and in line with these Terms.</li>
                <li>Keep your profile accurate and current.</li>
                <li>Respect intellectual property and privacy of others.</li>
            </ul>

            <h3>You must not:</h3>
            <ul>
                <li>Post harmful, harassing, or illegal content.</li>
                <li>Impersonate individuals or misrepresent affiliation.</li>
                <li>Use scraping, bots, or unauthorized automation.</li>
                <li>Violate laws or community standards.</li>
            </ul>

            <h2>4. Content & Intellectual Property</h2>
            <ul>
                <li>You retain ownership of your posts, profile details, and uploads.</li>
                <li>
                    You grant Aspire a non-exclusive, worldwide, royalty-free licence to display,
                    store, modify, and distribute your content solely to operate the services and as
                    guided by your privacy settings.
                </li>
                <li>
                    You are solely responsible for ensuring any content you post is lawful and that
                    you have all required rights.
                </li>
            </ul>

            <h2>5. Paid Services & Billing</h2>
            <ul>
                <li>
                    Optional services (e.g., premium features) require payment via accepted methods.
                </li>
                <li>You agree to billing schedules, auto-renewal details, and applicable taxes.</li>
                <li>
                    Cancellations and refunds are handled per our <strong>Refund Policy</strong>.
                </li>
            </ul>

            <h2>6. Termination</h2>
            <ul>
                <li>
                    We may suspend or terminate accounts or access at our discretion for violations
                    of these Terms.
                </li>
                <li>
                    You may close your account at any time by following the process outlined in your
                    Account Settings.
                </li>
                <li>Sections such as licenses, disclaimers, and liability survive termination.</li>
            </ul>

            <h2>7. Disclaimers & Liability</h2>
            <ul>
                <li>
                    Services are provided &ldquo;<strong>as is</strong>&rdquo; and &ldquo;
                    <strong>as available</strong>&rdquo; without warranties of any kind.
                </li>
                <li>Aspire is not liable for indirect, incidental, or consequential damages.</li>
                <li>
                    Maximum aggregate liability is the greater of the total subscription fees paid
                    in the last 12 months or CAD $1,000, subject to applicable law.
                </li>
            </ul>

            <h2>8. Dispute Resolution & Governing Law</h2>
            <ul>
                <li>
                    <strong>For users in Canada:</strong> governed by the laws of{" "}
                    <strong>Canada and Ontario</strong>, with disputes resolved in Ontario courts.
                </li>
                <li>
                    <strong>For users elsewhere:</strong> governed by Ontario law, with consent to
                    Ontario courts.
                </li>
            </ul>

            <h2>9. Modifications</h2>
            <p>
                We reserve the right to modify these Terms at any time. Significant changes will be
                communicated via email or platform. Continued use after notice implies acceptance.
            </p>

            <h2>10. Communications</h2>
            <p>
                You consent to receive notices electronically via your registered email or through
                Aspire messaging.
            </p>

            <h2>11. General</h2>
            <ul>
                <li>
                    These Terms constitute the full agreement between you and Aspire, replacing any
                    prior agreements.
                </li>
                <li>If a provision is deemed unenforceable, remaining provisions remain valid.</li>
                <li>No waiver of rights occurs unless in writing and signed by both parties.</li>
                <li>You may not assign your rights; Aspire may assign its rights freely.</li>
            </ul>
        </div>
    );
};

export default TermsOfUse;
